import React from "react";
import UnifiedDocument from "./UnifiedDocument";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const UnifiedQuotation = () => {
  return <UnifiedDocument documentType={DOCUMENT_TYPES.QUOTATION} />;
};

export default UnifiedQuotation;
